<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { DgrDialog } from '@stockmarkteam/donguri-ui';
import { getRubyStringLength } from '@/utils/getRubyStringLength';
import { SURVEY_QUESTION_MAX_LENGTH } from '@/utils/survey/constants';

type Props = {
  title: string;
};
const props = defineProps<Props>();

type Emits = {
  editShareSurveyTitle: [title: string];
};
const emit = defineEmits<Emits>();

// NOTE: 現状タイトルにはスレッド作成時のプロンプトがそのまま入るため、プロンプトと同じ上限にする
// TODO: タイトルを短くする
const MAX_TITLE_LENGTH = SURVEY_QUESTION_MAX_LENGTH;

const open = defineModel<boolean>('open', { default: false });

const editableTitle = ref('');

// NOTE: ruby-grapeのmax_lengthのバリデーションで使用するRubyのString#lengthメソッドに合わせる
const isValidTitleLength = computed(
  () => getRubyStringLength(editableTitle.value) <= MAX_TITLE_LENGTH,
);

const enableSubmitButton = computed(() => {
  return editableTitle.value.trim().length > 0 && isValidTitleLength.value;
});

// モーダルが開いた時にタイトルを初期化
watch(open, isOpen => {
  if (isOpen) {
    editableTitle.value = props.title;
  }
});

const editShareSurveyTitle = () => {
  emit('editShareSurveyTitle', editableTitle.value);
  closeModal();
};

const closeModal = () => {
  open.value = false;
};
</script>

<template>
  <DgrDialog v-model:open="open" title="タイトルを編集" submit-label="保存">
    <template #description>
      <div class="description">
        <div>
          <label for="share-survey-title" class="c-text-regular--m title-label">
            シェアスレッドのタイトル
          </label>
          <textarea
            id="share-survey-title"
            class="c-textArea title-textarea"
            v-model.trim="editableTitle"
            placeholder="タイトルを入力してください"
            autofocus
          />
          <div v-if="!isValidTitleLength" class="validation-error-message">
            <span class="c-text-regular--m">
              タイトルの最大文字数は{{ MAX_TITLE_LENGTH }}文字です
            </span>
          </div>
        </div>
      </div>
    </template>
    <template #submit>
      <button
        class="c-btn c-btn--auto c-btn--AnewsPrimary"
        :disabled="!enableSubmitButton"
        :class="{ disabled: !enableSubmitButton }"
        @click="editShareSurveyTitle"
      >
        保存
      </button>
    </template>
  </DgrDialog>
</template>

<style lang="scss" scoped>
.description {
  width: 648px;
  height: auto;
}

.title-label {
  display: inline-block;
  margin-bottom: 4px;
}

.title-textarea {
  height: 338px;
  resize: vertical;
  width: 100%;
}

.validation-error-message {
  color: $color-orange1000;
  margin-top: 8px;
}

button.disabled {
  border: none;
  &:hover {
    border: none;
  }
}
</style>
